import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import { auth } from '$lib/stores/Auth.svelte';

const { VITE_SH_STORE, VITE_SH_API_VERSION, VITE_STOREFRONT_TOKEN } = import.meta.env;

export const shClient = createStorefrontApiClient({
  storeDomain: VITE_SH_STORE,
  apiVersion: VITE_SH_API_VERSION,
  publicAccessToken: VITE_STOREFRONT_TOKEN,
});

import { createGraphQLClient } from '@shopify/graphql-client';
import { type GraphQLClient } from '@shopify/graphql-client';
import { Type } from '@lucide/svelte';

const SHOP_ID = 25919193148

/**
 * Endpoint format for the Customer Account API:
 * https://shopify.com/<shop id>/account/customer/api/<version>/graphql.json
 * Shares VITE_SH_API_VERSION with the Storefront client.
 */
const CUSTOMER_ENDPOINT =
  `https://shopify.com/${SHOP_ID}/account/customer/api/${VITE_SH_API_VERSION}/graphql.json`;

const ca_client_container = $state({
  client: null as GraphQLClient | null,
})


export const caClient = () => {
  if (ca_client_container.client) {
    return ca_client_container.client;
  }
  ca_client_container.client = createCustomerApiClient();
  return ca_client_container.client;
};


export const createCustomerApiClient = () => {
  /**
   * The access-token is issued by the OAuth 2 / PKCE flow for
   * *new* customer accounts and is **not** the classic
   * `customerAccessToken` from Storefront API.
   */
  const token = auth.accessToken
  
  console.log("Creating Customer API client with token:", token);

  return createGraphQLClient({
    url: CUSTOMER_ENDPOINT,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    }
  });
}
